import React from 'react';
import MedicationRow, { Medication } from '../MedicationRow/MedicationRow';
import './MedicationList.css';

interface MedicationListProps {
  medications: Medication[];
  onMedicationClick?: (med: Medication) => void;
  expandedMedId?: string | null;
  renderExpandedRow?: (med: Medication) => React.ReactNode;
}

// áður en ég bætti við edit row
// const MedicationList: React.FC<MedicationListProps> = ({ medications, onMedicationClick }) => (
//   <div className="medication-list">
//     {medications.map((med) => (
//       <MedicationRow key={med.id} med={med} onClick={onMedicationClick} />
//     ))}
//   </div>
// );

const MedicationList: React.FC<MedicationListProps> = ({
  medications,
  onMedicationClick,
  expandedMedId,
  renderExpandedRow,
}) => (
  <div className="medication-list">
    {medications.map((med) => (
      <div key={med.id} className="medication-list-item">
        {expandedMedId === med.id && renderExpandedRow ? (
          // EDIT MODE: show the inline “modal” INSTEAD of the row
          renderExpandedRow(med)
        ) : (
          <MedicationRow
            med={med}
            onClick={onMedicationClick ? () => onMedicationClick(med) : undefined}
          />
        )}
      </div>
    ))}
  </div>
);

export default MedicationList;
